import React from "react";
import ModificationDetails from "./ModificationDetails";
import Contact from "../../common/Contact/Contact";
import FooterThree from "../../common/Footer/FooterThree";
import Menu from "../../common/Menu/Menu";
import ModificationBanner from "./ModificationBanner";

const Modification = () => {
    return (
        <>
      <Menu header_style_2={true} />
      <ModificationBanner />
      <ModificationDetails />
      <Contact />
      <FooterThree />
    </>
    )
}
export default Modification;